import React, { useEffect } from "react";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { Helmet, HelmetProvider } from "react-helmet-async";
import Footer from "../../components/footer";
import AOS from "aos";
import "aos/dist/aos.css";
import { meta } from "../../content_option";
import faq from "../../assets/videos/Sonia.mp4";
import { Container } from "react-bootstrap";
import "./style.css";

export const PhotoGallary = () => {
  const mediaItems = [
    { type: "image", src: "/photogallary/1.webp" },
    // { type: "video", src: "/photogallary/about.mp4" },
    { type: "image", src: "/photogallary/2.webp" },
    { type: "image", src: "/photogallary/3.webp" },
    { type: "image", src: "/photogallary/4.webp" },
    { type: "image", src: "/photogallary/5.webp" },
    { type: "image", src: "/photogallary/6.webp" },
    // { type: "video", src: "/photogallary/about.mp4" },
    { type: "image", src: "/photogallary/7.webp" },
    { type: "image", src: "/photogallary/8.webp" },
    // { type: "image", src: "/photogallary/Web-9-min.jpg" },
    { type: "image", src: "/photogallary/9.webp" },
    { type: "image", src: "/photogallary/10.webp" },
    // { type: "video", src: "/photogallary/about.mp4" },
    { type: "image", src: "/photogallary/11.webp" },
    { type: "image", src: "/photogallary/12.webp" },
    { type: "image", src: "/photogallary/13.webp" },
    { type: "image", src: "/photogallary/14.webp" },
    { type: "image", src: "/photogallary/15.webp" },
    { type: "image", src: "/photogallary/16.webp" },
    { type: "image", src: "/photogallary/17.webp" },
    { type: "image", src: "/photogallary/18.webp" },
    { type: "image", src: "/photogallary/19.webp" },
    { type: "image", src: "/photogallary/20.webp" },
    { type: "image", src: "/photogallary/21.webp" },
    { type: "image", src: "/photogallary/22.webp" },
    { type: "image", src: "/photogallary/23.webp" },
    { type: "image", src: "/photogallary/24.webp" },
    { type: "image", src: "/photogallary/25.webp" },
    { type: "image", src: "/photogallary/26.webp" },
    { type: "image", src: "/photogallary/27.webp" },
    { type: "image", src: "/photogallary/28.webp" },
    { type: "image", src: "/photogallary/29.webp" },
    { type: "image", src: "/photogallary/30.webp" },
    { type: "image", src: "/photogallary/31.webp" },
    { type: "image", src: "/photogallary/32.webp" },
    { type: "image", src: "/photogallary/33.webp" },
    { type: "image", src: "/photogallary/34.webp" },
    { type: "image", src: "/photogallary/35.webp" },
    { type: "image", src: "/photogallary/36.webp" },
    { type: "image", src: "/photogallary/37.jpg" },
    { type: "image", src: "/photogallary/38.webp" },
    { type: "image", src: "/photogallary/39.webp" },
    { type: "image", src: "/photogallary/40.webp" },
    { type: "image", src: "/photogallary/41.webp" },
    { type: "image", src: "/photogallary/42.webp" },
    { type: "image", src: "/photogallary/43.jpg" },
    { type: "image", src: "/photogallary/44.jpg" },
    { type: "image", src: "/photogallary/45.jpg" },
    { type: "image", src: "/photogallary/46.jpg" },
    { type: "image", src: "/photogallary/47.jpg" },
    { type: "image", src: "/photogallary/48.jpg" },
    { type: "image", src: "/photogallary/49.jpg" },
    { type: "image", src: "/photogallary/50.jpg" },
    { type: "image", src: "/photogallary/51.jpg" },
    { type: "image", src: "/photogallary/52.jpg" },
    { type: "image", src: "/photogallary/53.jpg" },
    { type: "image", src: "/photogallary/54.jpg" },
    { type: "image", src: "/photogallary/55.jpg" },
    { type: "image", src: "/photogallary/56.jpg" },
    { type: "image", src: "/photogallary/57.jpg" },
    { type: "image", src: "/photogallary/58.jpg" },
    { type: "image", src: "/photogallary/59.jpg" },
    { type: "image", src: "/photogallary/60.jpg" },
    { type: "image", src: "/photogallary/61.jpg" },
    { type: "image", src: "/photogallary/62.jpg" },
    { type: "image", src: "/photogallary/63.jpg" },
    { type: "image", src: "/photogallary/64.jpg" },
    { type: "image", src: "/photogallary/65.jpg" },
    { type: "image", src: "/photogallary/66.jpg" },
    { type: "image", src: "/photogallary/67.jpg" },
    { type: "image", src: "/photogallary/68.jpg" },
    { type: "image", src: "/photogallary/69.jpg" },
    { type: "image", src: "/photogallary/70.jpg" },
    { type: "image", src: "/photogallary/71.jpg" },
    { type: "image", src: "/photogallary/72.jpg" },
    { type: "image", src: "/photogallary/73.jpg" },
    { type: "image", src: "/photogallary/74.jpg" },
    { type: "image", src: "/photogallary/75.jpg" },
  ];
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <HelmetProvider>
      <Helmet>
        <meta charSet="utf-8" />
        <title>PhotoGallary | {meta.title}</title>
        <meta name="description" content={meta.description} />
      </Helmet>

      <div style={{
         pointerEvents: 'none',  
         position: 'relative' 
      }}>
        <video
          src={faq}
          autoPlay
          loop
          muted
          className="vid"
          playsInline
          controlsList="nodownload nofullscreen noremoteplayback"
          disablePictureInPicture
          style={{
            // height: "38vh",
            width: "100%",
            // position: "absolute",
            objectFit: "cover",
            // zIndex: "-1",
            top: 0,
            // height: "100vh",
            pointerEvents: 'none',  // Extra protection against interaction
            userSelect: 'none',     // Prevent text selection
            WebkitTouchCallout: 'none'
          }}
        ></video>

      </div>

      <Container>
        <div className="gallery-container" style={{ marginTop: "40px"}}>
          <h2
          className="siz"
            style={{
              textAlign: "center",
              color: "#333",
              marginBottom: "55px",
              fontFamily:"BannerFont"
            }}
          >
            Together is a beautiful place to be
          </h2>
          {/* <div className="test-container" style={{ marginBottom: "70px" }}>
            <div>
              <p>
                At Made In Heaven, we understand that every moment of your wedding journey is meaningful. Our photography package is designed to give you the flexibility to choose the coverage that suits your needs, letting you decide the hours for each event, big or small. We’re here to capture all the pre-wedding events you want us to document, preserving each one with the care and attention it deserves.
                This package includes options for 2-hour and 3-hour pre-wedding events, each priced as shown below. For any additional time, we offer an extended hourly rate of $300/hour, allowing you to enjoy complete, uninterrupted coverage of your celebration.
              </p>
            </div>
          </div> */}
          <ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 3 }}>
            <Masonry gutter="30px">
              {mediaItems.map((item, index) =>
                item.type === "image" ? (
                  <img
                    key={index}
                    src={item.src}
                    alt={`Gallery Item ${index + 1}`}
                    style={{
                      width: "100%",
                      display: "block",
                    }}
                    data-aos="zoom-in"
                  />
                ) : (
                  <video
                    key={index}
                    src={item.src}
                    autoPlay
                    loop
                    muted
                    // controls
                    style={{
                      width: "100%",
                      display: "block",
                    }}
                    data-aos="zoom-in"
                  ></video>
                )
              )}
            </Masonry>
          </ResponsiveMasonry>

        </div>
      </Container>
      <Footer />
    </HelmetProvider>
  );
};
